// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__1fqr3","navigationBarWrapper":"styles_navigationBarWrapper__1nVcc","pageContentWrapper":"styles_pageContentWrapper__35JUy"};